import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getGameFreespin = (params) => {
    return axios.get(`${backendHost}/api/admin/fs-game/list/status`, {params});
};

export {
    getGameFreespin
}